import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

interface RegenerarListaPasajerosModalState {
  isOpen: boolean
  reservaId: number
  cartaNombre: string
}

const initialState: RegenerarListaPasajerosModalState = {
  isOpen: false,
  reservaId: 0,
  cartaNombre: '',
}

const regenerarListaPasajerosModalSlice = createSlice({
  name: 'regenerarListaPasajerosModal',
  initialState,
  reducers: {
    openRegenerarListaPasajerosModal(
      state,
      action: PayloadAction<{ reservaId: number; cartaNombre: string }>,
    ) {
      state.isOpen = true
      state.reservaId = action.payload.reservaId
      state.cartaNombre = action.payload.cartaNombre
    },
    closeRegenerarListaPasajerosModal(state) {
      state.isOpen = false
      state.reservaId = 0
      state.cartaNombre = ''
    },
  },
})

export const { openRegenerarListaPasajerosModal, closeRegenerarListaPasajerosModal } =
  regenerarListaPasajerosModalSlice.actions

const RegenerarListaPasajerosModalReducer = regenerarListaPasajerosModalSlice.reducer

export default RegenerarListaPasajerosModalReducer
